module.exports = __webpack_public_path__ + "static/media/himachal_pradesh.ec461f0e.png";